<template>
  <div>
    <input ref="input" type="file" @change="onFileInputChange" :accept="acceptedFileTypes ? acceptedFileTypes.join(',') : undefined" hidden multiple />
    <div
      class="wrapper"
      :class="{active}"
      @dragover.prevent="onDragover"
      @drop.prevent="onDrop"
      @dragenter.prevent="onDragEnter"
      @dragleave.prevent="onDragLeave"
    >
      <div class="overlay"/>
      <slot v-bind:manualSelect="manualSelect" v-bind:active="active"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    acceptedFileTypes: Array
  },
  data() {
    return {
      active: false,
      error: false
    };
  },
  methods: {
    manualSelect() {
      this.$refs.input.click();
    },
    onDragover(e) {
      this.active = true;
      e.dataTransfer.dropEffect = "copy";
    },
    onDrop(e) {
      this.active = false;
      this.emitFiles(e.dataTransfer.files);
    },
    onDragEnter() {
      this.active = false;
    },
    onDragLeave() {
      this.active = false;
    },
    onFileInputChange() {
      this.emitFiles(this.$refs.input.files);
    },
    emitFiles(files) {
      for (let file of files) {
        if (this.acceptedFileTypes && !this.acceptedFileTypes.includes(file.type)) continue;
        this.$emit("file-select", file);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  position: relative;
}
.overlay {
  pointer-events: none;
  display: none;
  position: absolute;
  top: -2px;
  right: -2px;
  bottom: -2px;
  left: -2px;
  border: 2px dashed rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.05);
}
.wrapper.active > .overlay {
  display: block;
}
</style>